import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_7135_43796)"
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_7135_43796"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "16",
  height: "16",
  fill: "white"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 16 16",
    fill: "none"
  }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M6.00016 2.66536V1.33203M10.0002 13.332V14.6654M2.66683 5.9987H1.3335M13.3335 9.9987H14.6668M3.27631 3.27484L2.3335 2.33203M12.724 12.7226L13.6668 13.6654M8.00016 11.7699L6.58595 13.1841C5.54455 14.2255 3.85611 14.2255 2.81471 13.1841C1.77331 12.1427 1.77331 10.4543 2.81471 9.41291L4.22893 7.9987M11.7714 7.9987L13.1856 6.58448C14.227 5.54309 14.227 3.85465 13.1856 2.81325C12.1442 1.77185 10.4558 1.77185 9.41438 2.81325L8.00016 4.22746",
    stroke: $props.color,
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_3)]), _hoisted_4], 8, _hoisted_1);
}